//takes two representations of dates and strings and compares them
export const compareDates = (transactionDateString: string, columnDateString: string) =>{
    const dateA = new Date(transactionDateString);
    dateA.setHours(0, 0, 0, 0);
    const dateB = new Date(columnDateString);
    dateB.setHours(0, 0, 0, 0);
    return dateA.getTime() === dateB.getTime();
}